import React from 'react';
import ToDoApp from './ToDoApp';

const App = () => {
  return <ToDoApp />;
};

export default App;
